// LumPet Gallery Autoplay - carrossel infinito 3s
// Usa monkey-patch do goToIndex para rastrear indice real sempre
(function () {
  var INTERVAL = 3000;

  function startAutoplay(sliderEl) {
    if (sliderEl.dataset.lpAutoplay) return;

    var tries = 0;
    var waitReady = setInterval(function () {
      tries++;
      if (typeof sliderEl.goToIndex === 'function') {
        clearInterval(waitReady);
        sliderEl.dataset.lpAutoplay = '1';
        runAutoplay(sliderEl);
      } else if (tries > 50) {
        clearInterval(waitReady);
      }
    }, 100);
  }

  function runAutoplay(sliderEl) {
    // currentIdx rastreado via patch - reflete QUALQUER navegacao
    // (autoplay ou clique do usuario na seta)
    var currentIdx = 0;

    // Patch do goToIndex: intercepta toda chamada, seja nossa ou do usuario
    var origGoToIndex = sliderEl.goToIndex.bind(sliderEl);
    sliderEl.goToIndex = function(idx) {
      currentIdx = parseInt(idx) || 0;
      return origGoToIndex(idx);
    };

    // Tambem observa cliques nas setas do slider para atualizar currentIdx
    // O Ecomus chama goToIndex internamente ao clicar na seta,
    // entao o patch ja captura - mas caso nao capture, ouve o pointerup
    sliderEl.addEventListener('pointerup', function() {
      // Pequeno delay para o Ecomus processar o clique primeiro
      setTimeout(function() {
        var slides = Array.from(sliderEl.querySelectorAll('.hdt-slider__slide:not([hidden])'));
        var sel = slides.findIndex(function(s) { return s.classList.contains('is-selected'); });
        if (sel !== -1) currentIdx = sel;
      }, 350);
    });

    setInterval(function () {
      var slides = sliderEl.querySelectorAll('.hdt-slider__slide:not([hidden])');
      var total = slides.length;
      if (total < 2) return;

      currentIdx = (currentIdx + 1) % total;
      origGoToIndex(currentIdx);
    }, INTERVAL);
  }

  function initSliders() {
    document.querySelectorAll('hdt-slider.hdt-medias-slider').forEach(startAutoplay);
  }

  var observer = new MutationObserver(function () {
    document.querySelectorAll('hdt-slider.hdt-medias-slider:not([data-lp-autoplay])').forEach(startAutoplay);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
